// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { ShapeElement } from './ShapeElement';
import { Double2D } from '../../../../../com/MetaPattern/MDA/Designer/Base/Double2D';
import { DiagramShape } from './DiagramShape';
import { ContainerShape } from './ContainerShape';
import { ScopeShape } from './ScopeShape';
/**
 * 节点图形 实体类
 * 定义一个节点，可以使用线来连接节点
 */
export class NodeShape extends ShapeElement {
  /** 是否可见 : 定义图形的可见性，false则隐藏图形 */
  private _isVisible: boolean;

  /** 设置：是否可见 */
  public get isVisible() {
    return this._isVisible;
  }

  /** 获取：是否可见 */
  public set isVisible(value: boolean) {
    this._isVisible = value;
  }

  /** 起始点 : 定义图形的左上角点坐标 */
  private _startPoint: Double2D;

  /** 设置：起始点 */
  public get startPoint() {
    return this._startPoint;
  }

  /** 获取：起始点 */
  public set startPoint(value: Double2D) {
    this._startPoint = value;
  }

  /** 当前尺寸 : 定义图形的当前尺寸，如果没有改变则等于初始尺寸 */
  private _curSize: Double2D;

  /** 设置：当前尺寸 */
  public get curSize() {
    return this._curSize;
  }

  /** 获取：当前尺寸 */
  public set curSize(value: Double2D) {
    this._curSize = value;
  }

  /** 元数据ID : 元数据ID，每个元数据对应一个图形的节点 */
  private _elementId: string;

  /** 设置：元数据ID */
  public get elementId() {
    return this._elementId;
  }

  /** 获取：元数据ID */
  public set elementId(value: string) {
    this._elementId = value;
  }

  /** 元数据类型 : 元数据类型 */
  private _elementType: string;

  /** 设置：元数据类型 */
  public get elementType() {
    return this._elementType;
  }

  /** 获取：元数据类型 */
  public set elementType(value: string) {
    this._elementType = value;
  }

  /** 是否展开 : 图形是否是展开状态，默认true */
  private _isExpend: boolean;

  /** 设置：是否展开 */
  public get isExpend() {
    return this._isExpend;
  }

  /** 获取：是否展开 */
  public set isExpend(value: boolean) {
    this._isExpend = value;
  }

  /** IsLocked : 锁定的图形不能进行任何的编辑操作 */
  private _isLocked: boolean;

  /** 设置：IsLocked */
  public get isLocked() {
    return this._isLocked;
  }

  /** 获取：IsLocked */
  public set isLocked(value: boolean) {
    this._isLocked = value;
  }

  /** 图表 的ID */
  private _diagram_ID: string;

  /** 获取：图表 的ID */
  public get diagram_ID() {
    return this._diagram_ID;
  }

  /** 设置：图表 的ID */
  public set diagram_ID(value: string) {
    this._diagram_ID = value;
  }

  /** 图表  */
  private _diagram: DiagramShape;

  /** 获取：图表  */
  public get diagram() {
    return this._diagram;
  }

  /** 设置：图表  */
  public set diagram(value: DiagramShape) {
    this._diagram = value;
    if (value !== null) {
      this.diagram_ID = value.id;
    } else {
      this.diagram_ID = '';
    }
  }

  /** 容器 的ID */
  private _container_ID: string;

  /** 获取：容器 的ID */
  public get container_ID() {
    return this._container_ID;
  }

  /** 设置：容器 的ID */
  public set container_ID(value: string) {
    this._container_ID = value;
  }

  /** 容器  */
  private _container: ContainerShape;

  /** 获取：容器  */
  public get container() {
    return this._container;
  }

  /** 设置：容器  */
  public set container(value: ContainerShape) {
    this._container = value;
    if (value !== null) {
      this.container_ID = value.id;
    } else {
      this.container_ID = '';
    }
  }

  /** 区域图形 */
  private _scopeShapes: Array<ScopeShape>;

  /** 获取：区域图形 */
  public get scopeShapes() {
    return this._scopeShapes;
  }

  /** 设置：区域图形 */
  public set scopeShapes(value: Array<ScopeShape>) {
    this._scopeShapes = value;
  }

  constructor() {
    super();
    this._isVisible = true;
    this._startPoint = new Double2D();
    this._curSize = new Double2D();
    this._elementId = '';
    this._elementType = '';
    this._isExpend = true;
    this._isLocked = false;
    this._diagram_ID = '';
    this._diagram = null;
    this._container_ID = '';
    this._container = null;
    this._scopeShapes = new Array<ScopeShape>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: NodeShape, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isVisible = element.isVisible;
      this.startPoint = element.startPoint;
      this.curSize = element.curSize;
      this.elementId = element.elementId;
      this.elementType = element.elementType;
      this.isExpend = element.isExpend;
      this.isLocked = element.isLocked;
      this.diagram_ID = element.diagram_ID;
      if (hasReference && element.diagram !== null) {
        this.diagram = element.diagram;
      }
      this.container_ID = element.container_ID;
      if (hasReference && element.container !== null) {
        this.container = element.container;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isVisible = json.IsVisible;
    this.startPoint = new Double2D(json.StartPoint.X, json.StartPoint.Y);
    this.curSize = new Double2D(json.CurSize.X, json.CurSize.Y);
    this.elementId = json.ElementId;
    this.elementType = json.ElementType;
    this.isExpend = json.IsExpend;
    this.isLocked = json.IsLocked;
    this.diagram_ID = json.Diagram_ID;
    // if (json.Diagram !== null) {
    //   this.diagram = DiagramShape.Create(json.Diagram);
    // }
    this.container_ID = json.Container_ID;
    // if (json.Container !== null) {
    //   this.container = ContainerShape.Create(json.Container);
    // }
    if (json.ScopeShapes && json.ScopeShapes.length > 0) {
      json.ScopeShapes.forEach((element: any) => {
        const scopeShape = ScopeShape.Create(element);
        // scopeShape.nodeShape = this;
        this.scopeShapes.push(scopeShape);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsVisible = this.isVisible;
    json.StartPoint = {};
    json.StartPoint.X = this.startPoint.x;
    json.StartPoint.Y = this.startPoint.y;
    json.CurSize = {};
    json.CurSize.X = this.curSize.x;
    json.CurSize.Y = this.curSize.y;
    json.ElementId = this.elementId;
    json.ElementType = this.elementType;
    json.IsExpend = this.isExpend;
    json.IsLocked = this.isLocked;
    json.Diagram_ID = this.diagram_ID;
    json.Container_ID = this.container_ID;
    if (this.scopeShapes && this.scopeShapes.length > 0) {
      json.ScopeShapes = [];
      this.scopeShapes.forEach((element) => {
        json.ScopeShapes.push(element.toJson());
      });
    }
  }

  static Create(json: any): NodeShape {
    const nodeShape = new NodeShape();
    nodeShape.Deserialize(json);
    nodeShape.json = json;
    return nodeShape;
  }
}
